import {AppRootState} from "./initial-state";
import {AppEnvState} from "~/state/reducers/app-env-reducer.ts";
import {Term} from "~/types/term-type.ts";
import {CommonWorktag, Worktag} from "~/types/common-worktag-type.ts";
import {ApiKeyInfo} from "~/types/api-key-type.ts";
import {ApiKeyState} from "~/state/reducers/api-key-reducer.ts";

export default {
    getCustomerNumber: (state: AppRootState): string => state.erp.deploymentContext?.cnum,
    getAppContext: (state: AppRootState): string => state.erp.deploymentContext?.ctx,
    getServerBase: (state: AppRootState): string => state.erp.deploymentContext?.serverBase,
    getDeploymentContextError: (state: AppRootState): string => state.erp.deploymentContext?.error,

    getSettings: (state: AppRootState) => state.erp.settings,

    isTnUser: (state: AppRootState): boolean => state.erp.currentUser?.isTnUser,

    getAppEnv: (state: AppRootState): AppEnvState => state.erp.appEnv,

    getActiveTerms: (state: AppRootState): Term[] => state.erp.terms?.active,
    getInactiveTerms: (state: AppRootState): Term[] => state.erp.terms?.inactive,
    getNewTerms: (state: AppRootState): Term[] => state.erp.terms?.new,

    getCodes: (state: AppRootState) => state.erp.codes?.codes,
    getMetaCodes: (state: AppRootState) => state.erp.codes?.meta,
    getCurrentCode: (state: AppRootState) => state.erp.codes?.currentCode,

    getWorktags: (state: AppRootState): string[] => state.erp.worktag?.worktags,
    getCurrentCommonWorktags: (state: AppRootState): CommonWorktag[] => state.erp.worktag?.currentCommonWorktags,
    getMetaWorktags: (state: AppRootState) => state.erp.worktag?.meta,

    getApiKeyInfo: (state: AppRootState) : ApiKeyInfo => state.erp.apiKey?.info,
    getApiKeyMeta: (state: AppRootState) => state.erp.apiKey?.meta,
    getApiKeyForbidden: (state: AppRootState): boolean => Boolean(state.erp.apiKey?.meta?.forbidden),
    getApiKeyNotSupported: (state: AppRootState): boolean => Boolean(state.erp.apiKey?.meta?.notSupported),
    getApiKeyError: (state: AppRootState) : string => state.erp.apiKey?.error,


};
